
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-6a6dfcab&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./CirclesToRhombusesSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./CirclesToRhombusesSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-6a6dfcab!../../../../vue-loader/lib/selector?type=template&index=0!./CirclesToRhombusesSpinner.vue"),
  /* scopeId */
  "data-v-6a6dfcab",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/CirclesToRhombusesSpinner.vue
// module id = 859
// module chunks = 1